// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w100[data-v-e32ebbf0] {\n  width: 80%;\n  height: 32px;\n}\n.flex-between[data-v-e32ebbf0] {\n  display: flex;\n  justify-content: space-between;\n}\n.mrl20[data-v-e32ebbf0] {\n  margin-left: 20px;\n}\n.flex[data-v-e32ebbf0] {\n  display: flex;\n}\n[data-v-e32ebbf0] .el-link {\n  align-items: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
